import React from 'react';
import { useObservable } from 'react-use-observable';

import { Button } from 'antd';

import isAfter from 'date-fns/isAfter';
import startOfDay from 'date-fns/startOfDay';
import { Form as FormikForm, Field, useFormikContext } from 'formik';
import { FilterActions } from 'v2/components/Pages/Reports/FilterActions';
import { FilterPanel } from 'v2/components/Pages/Reports/FilterPanel';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectAffiliate } from 'v2/components/Shared/FormFields/SelectAffiliate';
import type { IAffiliateCommissionFilter } from 'v2/interfaces/reports/affiliateCommissions';
import { affiliateCommissionsService, initialFilter } from 'v2/services/reports/affiliateCommissions';

import { Icon } from '@eduzz/ui-antd-theme';

export const Form = () => {
  const { isValid, isSubmitting, resetForm, dirty } = useFormikContext<IAffiliateCommissionFilter>();

  const [isLoading] = useObservable(() => affiliateCommissionsService.isLoading(), []);

  const isOutsideRange = (day: Date) => isAfter(startOfDay(day), startOfDay(new Date()));

  const handleClean = () => {
    resetForm({ values: initialFilter });
  };

  const isCleanDisabled = !dirty || isSubmitting || isLoading;
  const isFilterDisabled = !isValid || isSubmitting || isLoading;

  return (
    <FormikForm>
      <FilterPanel id='commissions-paid-to-affiliates'>
        <div className='grid grid-cols-1 items-end gap-4 sm:grid-cols-2 md:grid-cols-12'>
          <div className='md:col-span-3'>
            <Field
              label='Período'
              id='date'
              name='date'
              component={DateRangePickerFormField}
              isPresetLonger
              isOutsideRange={isOutsideRange}
            />
          </div>
          <div className='md:col-span-5'>
            <Field
              id='affiliates'
              name='affiliates'
              label='Afiliados'
              placeholder='Selecione o(s) afiliado(s)'
              component={SelectAffiliate}
              fullWidth
            />
          </div>
          <div className='md:col-span-4'>
            <FilterActions>
              <Button id='clean-filter-button' onClick={handleClean} type='text' disabled={isCleanDisabled}>
                Limpar
              </Button>
              <Button
                id='filter-button'
                type='primary'
                disabled={isFilterDisabled}
                htmlType='submit'
                loading={isSubmitting || isLoading}
                icon={<Icon.Funnel />}
              >
                Filtrar
              </Button>
            </FilterActions>
          </div>
        </div>
      </FilterPanel>
    </FormikForm>
  );
};
